 <template>
  <div class="right">
    <RightTop @data="getCreditDataFn"></RightTop>
    <div class="rightCenter">
      <div class="centerTit">限售解禁</div>
      <div class="centerCon">
        <div class="no">
          <span></span>
        </div>
        <div class="excel" @click="downloadTable()">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <!-- 表格纵列 -->
        <div class="tabulationTop">
          <div class="title"></div>
          <div class="con"></div>
        </div>
        <!-- 下部横向 -->
        <div class="tabulationBottom">
          <el-table :data="sellList" style="width: 100%" border size="mini">
            <el-table-column label="序号" width="60">
              <template slot-scope="scope">{{(page - 1) *limit+scope.$index+1}}</template>
            </el-table-column>
            <af-table-column prop="liftBanDate" label="解禁日期"></af-table-column>
            <af-table-column prop="liftedBanNumber" label="解禁数量(万股)"></af-table-column>
            <af-table-column prop="bannedShareMarketValue" label="解禁股流通市值(亿元)"></af-table-column>
            <af-table-column prop="listBatche" label="上市批次"></af-table-column>
            <af-table-column prop="announcementDate" label="公告日期"></af-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="rightPaging">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="totlalCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import RightTop from "@/components/rightTop.vue";

export default {
  props: {},
  components: {
    RightTop
  },
  data() {
    return {
      stockCode: "",
      enterpriseCode: "",

      sellList: [],
      currentPage4: 1,
      offset: 0, //从多少条开始
      limit: 10, //每页多少条
      totlalCount: 0, //总条数
      page: 1
    };
  },
  computed: {},
  methods: {
    //   获取头部数据
    getCreditDataFn(data) {
      this.stockCode = data[0].companyStockCode;
      this.enterpriseCode = data[0].enterpriseCode;
      this.getEquityRestrictionData();
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val;
      this.offset = (val - 1) * this.limit;
      this.getEquityRestrictionData();
    },
    // 限售解禁数据
    getEquityRestrictionData() {
      let parmars = {
        stockCode: this.stockCode,
        enterpriseCode: this.enterpriseCode,
        offset: this.offset,
        limit: this.limit
      };
      api.stockSell(parmars).then(res => {
        this.totlalCount = res.data.total;
        this.sellList = res.data.rows;
        // console.log(this.sellList,99999999999)
      });
    },
    // 下载
    downloadTable() {
      this.download(
        window.baseUrl +
          "/capitalStructure/downEquityRestrictionData?stockCode=" +
          this.stockCode +
          "&enterpriseCode=" +
          this.enterpriseCode
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;

  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        cursor: pointer;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      .tabulationTop {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        .title {
          width: 140px;
          table th {
            width: 140px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #dfdfdf;
            padding-left: 11px;
            vertical-align: middle;
          }
        }
        .con {
          flex: 1;
          table {
            width: 100%;
          }
          table td {
            width: 16%;
            height: 40px;
            line-height: 40px;
            border: 1px solid #dfdfdf;
            padding-left: 11px;
            // text-align: center;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .rightPaging {
    width: auto;
    padding: 0 20px;
    padding-top: 40px;
    margin-right: 20px;
    height: 84px;
  }
}
/deep/ .el-table th {
  display: table-cell !important;
}
</style>


// WEBPACK FOOTER //
// src/view/stock/sell.vue